export default "__VITE_ASSET__DlMSYNVU__"